import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import TemplateHeader from "./TemplateHeader.jsx";
import TemplateAside from "./TemplateAside.jsx";
import "./assets/scss/style.scss";
import TemplateFooter from "./TemplateFooter.jsx";
import LegalUpdatesGate from "./LegalUpdatesGate.jsx";
import api from "@/api/api.js";
import { useCompany } from "@/context/CompanyContext.jsx";
import { PageTitleContext } from "@/context/PageTitleContext.jsx";

/**
 * `breadcrumb` permite que la miga de pan diga algo más corto que el título
 * (p. ej. título "Lista de clientes para facturar" / miga "Lista de clientes").
 * Si no se pasa, la miga repite el título. `breadcrumb={false}` es para la propia página
 * de inicio: la miga es sólo "Inicio", sin repetirse.
 *
 * Una pantalla puede cambiar su título y su miga con `usePageTitle`.
 */
const TemplateAdmin = ({ content, title, breadcrumb }) => {
  const { t } = useTranslation();
  const [pageTitle, setPageTitle] = useState(null);
  const shownTitle = pageTitle?.title ?? title;
  const shownBreadcrumb = pageTitle
    ? (pageTitle.breadcrumb ?? pageTitle.title)
    : (breadcrumb ?? title);
  const { setSelectedCompany, setCompanies } = useCompany();

  const fetchCompanies = async (user) => {
    const response = await api.get(`/users/${user}.json`);
    const companies = response.data.companies ?? [];

    if (companies.length > 0) {
      setCompanies(companies);
    }

    // `companies` trae también las archivadas, porque el contador las consulta
    // en su historial. Quedarse con la primera de esa lista ataba la sesión a
    // una empresa que ya no cuenta, y entonces el Inicio, los folios y los
    // clientes salían vacíos sin que el usuario pudiera cambiarlo: ya no hay
    // selector de empresa. La vigente la dice el servidor.
    if (response.data.activeCompanyId) {
      setSelectedCompany(response.data.activeCompanyId);
    }
  };
  useEffect(() => {
    const user = sessionStorage.getItem("user");
    fetchCompanies(user);
  }, []);

  return (
    <>
      <TemplateHeader />
      <TemplateAside />
      <LegalUpdatesGate />

      <main id="main" className="main" style={{ backgroundColor: "#f6f9ff" }}>
        <div className="pagetitle">
          <h1>{shownTitle}</h1>
          <nav>
            <ol className="breadcrumb">
              {shownBreadcrumb === false ? (
                <li className="breadcrumb-item active">{t("page.home")}</li>
              ) : (
                <>
                  <li className="breadcrumb-item">
                    <Link to="/dashboard">{t("page.home")}</Link>
                  </li>
                  <li className="breadcrumb-item active">{shownBreadcrumb}</li>
                </>
              )}
            </ol>
          </nav>
        </div>
        <section className="section p-0">
          <PageTitleContext.Provider value={setPageTitle}>
            <div className="row">{content}</div>
          </PageTitleContext.Provider>
        </section>
      </main>

      <TemplateFooter />
    </>
  );
};

export default TemplateAdmin;
